export default "__VITE_ASSET__M6r8ihoL__"